// Home.jsx
import React from 'react';
import Hero from '../Pages/Hero/Hero';
import Contact from '../Pages/Contct/Contact';
import Program from '../Pages/Programs/Programs';
import BlogPromo from '../Pages/BlogPromo/BlogPromo';

const Home = () => {
  return (
    <>
      <Hero />
      <Program />
      <BlogPromo />
      <Contact />
    </>
  );
};

export default Home;
